// extracted by mini-css-extract-plugin
export default {"starRating":"StarRating_starRating__SRgmL"};